export class TagCategory {
  id: number = 0;
  label: string = '';
  tagIds: number[] = [];

  public static createFromJson(input: any): TagCategory {
    const data = new TagCategory();
    data.fromJson(input);
    return data;
  }

  fromJson(input: any) {
    this.id = input["id"];
    this.label = input["label"];
    if (input["tagIds"]) {
      for (const child of input["tagIds"]) {
        this.tagIds.push(child);
      }
    }
  }

  toJson(): any {
    return {
      id: this.id,
      label: this.label,
      tagIds: [...this.tagIds]
    };
  }
}
